import { Component, input } from '@angular/core';
import { DmContentDivider, DmLabelSection } from '@digitale-menschen/component-library-angular';

/**
 * One row of a Mein Profil form: a divider, the label on the left and the control on the right.
 *
 * A grid so the label column keeps one width down the whole form, and a plain media query on the
 * window, because the tab fills the page and is not narrower than it.
 */
@Component({
  selector: 'lp-mein-profil-row',
  imports: [DmContentDivider, DmLabelSection],
  templateUrl: './mein-profil-row.component.html',
  styleUrl: './mein-profil-row.component.scss',
  host: { class: 'dm-block' },
})
export class MeinProfilRowComponent {
  public readonly label = input.required<string>();
  public readonly hint = input<string | undefined>(undefined);
  public readonly required = input<boolean>(false);
}
